import type { IconSvgObject } from './types';

const EyeIcon: IconSvgObject = [
  ["path", { d: "M2 8C2 8 6.47715 3 12 3C17.5228 3 22 8 22 8", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21.544 13.045C21.848 13.4713 22 13.6845 22 14C22 14.3155 21.848 14.5287 21.544 14.955C20.1779 16.8706 16.6892 21 12 21C7.31078 21 3.8221 16.8706 2.45604 14.955C2.15201 14.5287 2 14.3155 2 14C2 13.6845 2.15201 13.4713 2.45604 13.045C3.8221 11.1294 7.31078 7 12 7C16.6892 7 20.1779 11.1294 21.544 13.045Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default EyeIcon;
